var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.fullscreenAvailable())?_c('button',{staticClass:"button",on:{"click":_vm.toggleFullscreen}},[(_vm.isFullscreen)?_c('span',[_vm._v("Exit fullscreen")]):_c('span',[_vm._v("Go fullscreen")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }